import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  grid-area: vote;
  display: flex;
  flex-direction: ${({ $viewMode }) =>
    $viewMode === "compact" ? "row" : "column"};
  align-items: ${({ $viewMode }) =>
    $viewMode === "compact" ? "center" : "stretch"};
  justify-content: flex-start;
  margin: 0;
  cursor: pointer;
  min-width: ${({ $viewMode }) => ($viewMode === "compact" ? "50px" : "80px")};

  > div {
    margin: ${({ $viewMode }) => ($viewMode === "compact" ? "0" : "0 0 10px")};
    border: 1px solid var(--brand);
    border-radius: ${({ $viewMode }) =>
      $viewMode === "compact" ? "4px" : "6px"};
    padding: ${({ $viewMode }) =>
      $viewMode === "compact" ? "4px 10px" : "12px 8px"};
    text-align: center;
    background-color: ${({ isVotedByMe }) =>
      isVotedByMe ? "var(--brand)" : "var(--white)"};
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${({ $viewMode }) =>
      $viewMode === "compact" ? "32px" : "52px"};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    }

    strong {
      display: block;
      font-size: ${({ $viewMode }) =>
        $viewMode === "compact" ? "16px" : "24px"};
      font-weight: 600;
      color: ${({ isVotedByMe }) =>
        isVotedByMe ? "var(--white)" : "var(--brand)"};
      line-height: 1;
      text-align: center;
      width: 100%;
    }
  }
`;

export const HeartIconWrapper = styled.div`
  position: relative;

  svg:nth-child(2) {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    transform: translate3d(-50%, -50%, 0);
    transform-origin: center center;
    transition: all 0.3s ease;
  }

  ${({ isVotedByMe }) =>
    isVotedByMe &&
    css`
      svg path {
        fill: var(--brand);
      }

      svg:nth-child(2) {
        width: 24px;
        height: 24px;
      }
    `}

  ${({ animateVote }) =>
    animateVote &&
    css`
      svg:nth-child(2) {
        animation: liked 0.4s ease forward;
      }
    `}

  @keyframes liked {
    0% {
      width: 0;
      height: 0;
    }
    50% {
      width: 34px;
      height: 34px;
    }
    100% {
      width: 24px;
      height: 24px;
    }
  }
`;
